import Vue from 'vue'

import PaUserAvatar from './PaUserAvatar'
import PaUserPicker from './PaUserPicker'

Vue.component('pa-user-avatar', PaUserAvatar)
Vue.component('pa-user-picker', PaUserPicker)
